import { useNavigate } from "react-router-dom";
import useAuthContext from "./useAuthContext";
import { useQueryClient } from "react-query";

const useLogout = () => {
  const { dispatcher } = useAuthContext();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logout = async () => {
    await queryClient.removeQueries();
    dispatcher({
      type: "LOGOUT",
    });
    localStorage.clear();
    navigate("/");
  };
  return { logout };
};

export default useLogout;
